import { createSlice } from "@reduxjs/toolkit";

export const stylingSlice = createSlice({
	name: "styling",
	initialState: {
		sidebarComponent: "",
	},

	reducers: {
		setSelectedSidebarComponent: (state, action) => {
			state.sidebarComponent = action.payload;
		}
	},
});

export const { setSelectedSidebarComponent } = stylingSlice.actions;

export default stylingSlice.reducer;
